export { apiMindbox } from 'next-flight-server-reference-proxy-loader?id=7f5a5c103c8f799646d6924251b25c554f061d6a18&name=apiMindbox!'